import { RooftopsCreateDto, RooftopUpdateDto, Pagination, PaginationQuery } from '@libs/dto';
import { Rooftop } from '@libs/models';

import { api } from '../common.api';

export const rooftopApi = api.injectEndpoints({
  endpoints: (build) => ({
    rooftopCreate: build.mutation<Rooftop, RooftopsCreateDto>({
      query: (body) => ({
        url: '/rooftop',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Rooftop'],
    }),
    rooftopUpdate: build.mutation<Rooftop, RooftopUpdateDto>({
      query: (body) => ({
        url: `/rooftop/${body.id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Rooftop'],
    }),
    rooftopIndex: build.query<Pagination<Rooftop>, PaginationQuery>({
      query: ({ q, page = 1, limit = 10 } = {}) => ({
        url: '/rooftop',
        method: 'GET',
        params: { q, page, limit },
      }),
      providesTags: ['Rooftop'],
    }),
    rooftopSearch: build.query<Pagination<Rooftop>, PaginationQuery>({
      query: ({ q, page = 1, limit = 10 }) => ({
        url: '/rooftop/search',
        method: 'GET',
        params: { q, page, limit },
      }),
      providesTags: ['Rooftop'],
    }),
    rooftopView: build.query<Rooftop, number>({
      query: (id) => ({
        url: `/rooftop/${id}`,
        method: 'GET',
      }),
      providesTags: ['Rooftop'],
    }),
    rooftopDelete: build.mutation<Rooftop, number>({
      query: (id) => ({
        url: `/rooftop/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Rooftop'],
    }),
  }),
});

export const {
  useRooftopCreateMutation,
  useRooftopUpdateMutation,
  useRooftopIndexQuery,
  useRooftopSearchQuery,
  useRooftopViewQuery,
  useRooftopDeleteMutation,
  useLazyRooftopIndexQuery,
  useLazyRooftopSearchQuery,
} = rooftopApi;
